class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class MailAccountRequestDto {
  /** 邮件地址 */
  address = "";

  /** 分配人编号 */
  assignee = "";

  /** 部门ID */
  departmentId = undefined;

  /** id */
  id = undefined;

  /** imap地址 */
  imap = "";

  /** imap端口 */
  imapPort = undefined;

  /** 是否启用ssl 0:否 1:是 */
  imapSsl = undefined;

  /** 名称 */
  name = "";

  /** 邮件密码 */
  password = "";

  /** smtp地址 */
  smtp = "";

  /** smtp端口 */
  smtpPort = undefined;

  /** 是否启用ssl 0:否 1:是 */
  smtpSsl = undefined;

  /** 状态 1:启用 2:停用 */
  status = undefined;
}

class MailAccountResponseDto {
  /** 邮件地址 */
  address = "";

  /** 分配人编号 */
  assignee = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 部门ID */
  departmentId = undefined;

  /** id */
  id = undefined;

  /** imap地址 */
  imap = "";

  /** imap端口 */
  imapPort = undefined;

  /** 是否启用ssl 0:否 1:是 */
  imapSsl = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 邮件密码 */
  password = "";

  /** smtp地址 */
  smtp = "";

  /** smtp端口 */
  smtpPort = undefined;

  /** 是否启用ssl 0:否 1:是 */
  smtpSsl = undefined;

  /** 状态 1:启用 2:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class MailMessageAttachmentResponseDto {
  /** 嵌入内容ID */
  contentId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 文件名 */
  fileName = "";

  /** 主机 */
  host = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 邮件ID */
  mailMessageId = undefined;

  /** 路径 */
  path = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class MailMessageDto {
  /** 应用 */
  appScopeEnum = "ALL";

  /** 帐号code */
  code = "";

  /** 收件内容 */
  content = "";

  /** messageId */
  messageId = "";

  /** 附件 */
  multipartDtoList = [];

  /** 收件时间 */
  receivedDate = "";

  /** 收件人 */
  receiver = "";

  /** 收件地址 */
  receiverAddress = "";

  /** 发送时间 */
  sentDate = "";

  /** 主题 */
  subject = "";

  /** uid */
  uid = undefined;
}

class MailMessageMultipartDto {
  /** 内嵌ID */
  contentId = "";

  /** 文件名 */
  fileName = "";

  /** host路径 */
  host = "";

  /** 相对路径 */
  path = "";
}

class MailMessageResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 邮件帐号ID */
  mailAccountId = undefined;

  /** message_id */
  messageId = "";

  /** 是否已读 1:是 2:否 */
  readFlag = undefined;

  /** 是否接收 1:是 0:否 */
  receiveFlag = undefined;

  /** 收件时间 */
  receivedTime = "";

  /** 接收人 */
  receiver = "";

  /** 接收人地址 */
  receiverAddress = "";

  /** 回复人 */
  replier = "";

  /** 回复人地址 */
  replierAddress = "";

  /** 发件时间 */
  sentTime = "";

  /** 状态 1:待处理 10:已处理 20:已关闭 */
  status = undefined;

  /** 主题 */
  subject = "";

  /** 工单ID */
  ticketId = undefined;

  /** uid */
  uid = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new IPage();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class TicketDetailResponseDto {
  /** 附件 */
  attachmentResponseDtos = [];

  /** 邮件内容 */
  content = "";

  /** id */
  id = undefined;

  /** 邮件帐号ID */
  mailAccountId = undefined;

  /** 是否接收 1:是 0:否 */
  receiveFlag = undefined;

  /** 收件时间 */
  receivedTime = "";

  /** 接收人 */
  receiver = "";

  /** 接收人地址 */
  receiverAddress = "";

  /** 回复人 */
  replier = "";

  /** 回复人地址 */
  replierAddress = "";

  /** 发件时间 */
  sentTime = "";

  /** 主题 */
  subject = "";

  /** 工单ID */
  ticketId = undefined;
}

class TicketInfoRequestDto {
  /** 分配人 */
  assignee = "";

  /** 备注 */
  memo = "";

  /** 状态 1:待处理 10:已处理 20:已关闭 */
  status = undefined;
}

class TicketReplyMultipartRequestDto {
  /** 内嵌ID */
  contentId = "";

  /** 文件名 */
  fileName = "";

  /** host路径 */
  host = "";

  /** 相对路径 */
  path = "";
}

class TicketReplyRequestDto {
  /** 收件内容 */
  content = "";

  /** 附件 */
  multipartDtoList = [];

  /** 主题 */
  subject = "";
}

class TicketResponseDto {
  /** 分配人编号 */
  assignee = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 预估回复时间 */
  estimateReplyTime = "";

  /** 到期时间 */
  expirationTime = "";

  /** id */
  id = undefined;

  /** 最新消息ID */
  lastMessageId = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 邮件帐号ID */
  mailAccountId = undefined;

  /** 备注 */
  memo = "";

  /** 是否已读 1:是 2:否 */
  readFlag = undefined;

  /** 接收人 */
  receiver = "";

  /** 接收人地址 */
  receiverAddress = "";

  /** 状态 1:待处理 10:已处理 20:已关闭 */
  status = undefined;

  /** 主题 */
  subject = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

export const crm = {
  IPage,
  MailAccountRequestDto,
  MailAccountResponseDto,
  MailMessageAttachmentResponseDto,
  MailMessageDto,
  MailMessageMultipartDto,
  MailMessageResponseDto,
  Response,
  ResponseDto,
  TicketDetailResponseDto,
  TicketInfoRequestDto,
  TicketReplyMultipartRequestDto,
  TicketReplyRequestDto,
  TicketResponseDto,
};
